module.exports = __webpack_public_path__ + "media/images/thumbs/atlas/vsens28-c47d585e1c3162a139dc593501d6b582.jpg";